import React from "react";
import Marquee from "react-fast-marquee";

const WORDS = ["Profesional", "Transparan", "Solutif", "Responsif", "Terintegrasi", "Terpercaya"];

export const BrandMarquee = () => {
  return (
    <section data-testid="marquee-section" className="bg-navy-dark py-10 md:py-14 border-y border-white/5 overflow-hidden">
      <Marquee speed={45} gradient={false} autoFill>
        {WORDS.map((w, i) => (
          <div key={`${w}-${i}`} className="flex items-center">
            <span className="font-serif text-4xl md:text-6xl text-transparent [-webkit-text-stroke:1px_rgba(212,175,55,0.55)] mx-8 select-none">
              {w}
            </span>
            <span className="text-gold text-2xl md:text-3xl">◆</span>
          </div>
        ))}
      </Marquee>
    </section>
  );
};
